import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationPage } from '../configuration';

/**
 * Generated class for the ConfigurationRoomsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-tips',
    templateUrl: 'configuration-tips.html',
})
export class ConfigurationTipsPage {
    tips: boolean;
    public form: FormGroup;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public configurationServices: ConfigurationServices,
        public globals: Globals,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        public translate: TranslateService) {

        if (!this.globals.restaurant.tip_1) {
            this.globals.restaurant.tip_1 = 0;
        }
        if (!this.globals.restaurant.tip_2) {
            this.globals.restaurant.tip_2 = 0;
        }
        if (!this.globals.restaurant.tip_3) {
            this.globals.restaurant.tip_3 = 0;
        }

        this.form = fb.group({
            tip_1: [this.globals.restaurant.tip_1, Validators.compose([Validators.required])],
            tip_2: [this.globals.restaurant.tip_2, Validators.compose([Validators.required])],
            tip_3: [this.globals.restaurant.tip_3, Validators.compose([Validators.required])],

        });
    }


    async updateIonToggle(tips) {
        this.globals.restaurant.tips = tips;
        this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'tips': tips,
        });
    }

    submit() {
        if (this.form.valid) {
            this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                'tip_1': this.form.value.tip_1,
                'tip_2': this.form.value.tip_2,
                'tip_3': this.form.value.tip_3,
            }).then(data => {
                this.globals.restaurant.tip_1 = this.form.value.tip_1;
                this.globals.restaurant.tip_2 = this.form.value.tip_2;
                this.globals.restaurant.tip_3 = this.form.value.tip_3;
                this.goBack();
            });


        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('configuration-tips-rellena-3-campos'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }


    goBack() {
        this.globals.side_menu_config_active = '';
        if (this.navCtrl.canGoBack())
            this.navCtrl.pop();
        else
            this.navCtrl.setRoot(ConfigurationPage);
    }




}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-tips/configuration-tips.ts